const STORAGE_KEY = 'clinic_api_base'

/**
 * Gerencia a URL base da API de forma dinâmica.
 * No mobile, a base muda conforme a clínica selecionada pelo usuário.
 * No web, o valor vem sempre do runtime config (subdomínio fixo no SSR).
 */
export function useApiBase() {
  const config = useRuntimeConfig()
  const defaultBase = config.public.apiBase as string

  const activeBase = useState<string>('api-base', () => {
    if (import.meta.client) {
      return localStorage.getItem(STORAGE_KEY) || defaultBase
    }
    return defaultBase
  })

  function setBase(url: string) {
    activeBase.value = url
    if (import.meta.client) {
      try { localStorage.setItem(STORAGE_KEY, url) } catch { /* ignora quota/privacidade */ }
    }
  }

  function resetBase() {
    activeBase.value = defaultBase
    if (import.meta.client) {
      try { localStorage.removeItem(STORAGE_KEY) } catch { /* ignora */ }
    }
  }

  return { activeBase, defaultBase, setBase, resetBase }
}
